import { CheckCircle2, Factory, ShieldCheck, Users } from "lucide-react";
import { SITE, STATS, VALUE_PROPS } from "@/lib/site";

const ICON_MAP = {
  factory: Factory,
  "shield-check": ShieldCheck,
  users: Users,
};

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32 bg-slate-50 border-t border-slate-200 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-5">
          <div className="overline mb-3 text-red-600">// 03 · About MKC</div>
          <h2 className="font-display font-black uppercase text-[#0A1128] text-4xl md:text-5xl tracking-tighter leading-[0.95] mb-6">
            Manufactured in India.<br />
            <span className="text-red-600">Trusted across India.</span>
          </h2>
          <p className="text-slate-700 text-base leading-relaxed mb-6">
            {SITE.about}
          </p>
          <p className="text-slate-700 text-base leading-relaxed mb-8">
            Master King Corps' wide range of equipment includes Bomb Disposal & EOD tool kits,
            Post-Blast Investigation kits, Remote Car Operating tool kits, Blasting Machines,
            Detonator Firing Systems, Hook & Line Sets, Manipulators, Letter-Bomb Detectors,
            Metal Detectors and other specialized tactical equipment.
          </p>

          <div className="space-y-4">
            {VALUE_PROPS.map((h) => {
              const Icon = ICON_MAP[h.icon] || ShieldCheck;
              return (
                <div key={h.title} className="flex items-start gap-4 border border-slate-200 bg-white p-5 lift shadow-hard">
                  <div className="w-10 h-10 border border-slate-300 flex items-center justify-center bg-slate-50 shrink-0">
                    <Icon className="w-5 h-5 text-red-600" />
                  </div>
                  <div>
                    <h4 className="font-display font-bold text-[#0A1128] text-base uppercase tracking-tight">{h.title}</h4>
                    <p className="text-slate-600 text-sm mt-1 leading-relaxed">{h.body}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="relative border border-slate-200 bg-white p-8 md:p-10 corner-tl corner-tr corner-bl corner-br shadow-hard">
            {/* Director's note */}
            <div className="overline text-red-600 mb-3">// MESSAGE FROM THE DIRECTOR</div>
            <blockquote className="font-display font-bold text-[#0A1128] text-2xl md:text-3xl tracking-tight leading-tight mb-6">
              "Our mission is to empower security forces with dependable, technologically advanced
              equipment that enhances operational capability while minimizing risk."
            </blockquote>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-[#0A1128] text-white flex items-center justify-center font-display font-black tracking-tight">
                GS
              </div>
              <div>
                <div className="font-display font-bold text-[#0A1128] text-base">{SITE.director}</div>
                <div className="overline">Director · Master King Corps</div>
              </div>
            </div>

            <div className="my-10 h-px bg-slate-200" />

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
              {STATS.map((s) => (
                <div key={s.label} className="bg-white p-6 text-center">
                  <div className="font-display font-black text-[#0A1128] text-3xl md:text-4xl tracking-tighter">
                    {s.value}
                  </div>
                  <div className="overline mt-2">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-8 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-emerald-700">
              <CheckCircle2 className="w-4 h-4" />
              Continuous focus on quality, innovation & customer satisfaction
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
